import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryBricksRequired extends MonthlySummaryError {
    constructor(options) {
        super('The number of bricks is not sent without promotional coupon', options);
    }
}
export default MonthlySummaryBricksRequired;
